__turbopack_context__.v({
  "grid": "styles-module-scss-module__hlD2Cq__grid",
  "gutter_0": "styles-module-scss-module__hlD2Cq__gutter_0",
  "gutter_12": "styles-module-scss-module__hlD2Cq__gutter_12",
  "gutter_15": "styles-module-scss-module__hlD2Cq__gutter_15",
  "gutter_20": "styles-module-scss-module__hlD2Cq__gutter_20",
  "gutter_25": "styles-module-scss-module__hlD2Cq__gutter_25",
  "gutter_30": "styles-module-scss-module__hlD2Cq__gutter_30",
  "gutter_50": "styles-module-scss-module__hlD2Cq__gutter_50",
  "layout_is_half": "styles-module-scss-module__hlD2Cq__layout_is_half",
  "layout_is_one_third_two_thirds": "styles-module-scss-module__hlD2Cq__layout_is_one_third_two_thirds",
  "layout_is_third": "styles-module-scss-module__hlD2Cq__layout_is_third",
  "layout_is_two_thirds_one_third": "styles-module-scss-module__hlD2Cq__layout_is_two_thirds_one_third",
  "vertical_bottom": "styles-module-scss-module__hlD2Cq__vertical_bottom",
  "vertical_center": "styles-module-scss-module__hlD2Cq__vertical_center",
  "vertical_top": "styles-module-scss-module__hlD2Cq__vertical_top",
});
